<template>
  <div>
    <Person
      v-if="role === Role.PERSON"
      :trustee-info="trusteeInfo"
      :assignee="assignee"
      :fill-type="fillType"
      @send="$emit('send', $event)"
    >
      <template #footer="{ next }">
        <slot name="footer" :next="next"></slot>
      </template>
    </Person>
    <Organization
      v-else
      :role="role"
      :trustee-info="trusteeInfo"
      :assignee="assignee"
      :fill-type="fillType"
      @send="$emit('send', $event)"
    >
      <template #footer="{ next }">
        <slot name="footer" :next="next"></slot>
      </template>
    </Organization>
  </div>
</template>

<script>
import Person from './Person';
import Organization from './Organization';
import { Role } from '@/utils/dictionaries';

export default {
  name: 'EgrnTrustee',
  components: {
    Person,
    Organization,
  },
  props: {
    role: {
      type: String,
      required: true,
    },
    trusteeInfo: {
      type: Object,
    },
    assignee: {
      type: Object,
    },
    fillType: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    Role,
  }),
};
</script>
